// import { Home, Box, DollarSign, UserPlus, Users, Chrome, Settings, Airplay, FolderPlus, File, Command, Cloud, Book, FileText, Server, Image, Sliders, Map, GitPullRequest, Calendar, Edit, Mail, MessageSquare, UserCheck, Layers, HelpCircle, Database, Headphones, Mic, ShoppingBag, Search, AlertOctagon, Lock, Briefcase, BarChart, Target, List } from "react-feather";
import { FaHome } from "react-icons/fa";
import { FaRegListAlt } from "react-icons/fa";
import { TbUsers } from "react-icons/tb";
import { FaRegBell } from "react-icons/fa";
import { LuSettings2 } from "react-icons/lu";
import { FiFileText } from "react-icons/fi";
import { FiBox } from "react-icons/fi";
import { FiTag } from "react-icons/fi";
import { FiBriefcase } from "react-icons/fi";
import { FiBookmark } from "react-icons/fi";
import { FiImage } from "react-icons/fi";
import { FiSettings } from "react-icons/fi";
import { FiGrid } from "react-icons/fi";

export const MENUITEMS = [
  {
    title: "Dashboard",
    icon: FaHome,
    type: "link",        // single link instead of dropdown
    path: "/dashboard",  // direct path
    active: false
  },
  {
    title: "Masters",
    icon: FaRegListAlt,
    type: "sub",
    badgeType: "primary",
    active: false,
    children: [
      { path: "/pages/groups", title: "Groups", type: "link" },
      { path: "/pages/size", title: "Size", type: "link" },
      { path: "/pages/category", title: "Category", type: "link" },
      { path: "/pages/brand", title: "Brand", type: "link" },
      { path: "/pages/material", title: "Material", type: "link" },
      { path: "/pages/color", title: "Color", type: "link" },
      { path: "/pages/offer-card-section-headline", title: "Offer Card Section Headeline", type: "link" },
    ],
  },
  {
    title: "Home banners",
    icon: FiImage,
    type: "sub",
    active: false,
    children: [
      { path: "/pages/home-banners/add", title: "Add New", type: "link" },
      { path: "/pages/home-banners/banner-list", type: "link", title: "Banner List" },
    ],
  },
   {
    title: "Manage Feature Card",
    icon: FiGrid ,
    type: "link",        // single link instead of dropdown
    path: "/pages/manage-feature-card",  // direct path
    active: false
  },
  {
    title: "Offer Card Section",
    icon: FiBookmark,
    type: "sub",
    active: false,
    children: [
      { path: "/pages/logo-management", title: "Header Logo", type: "link" },
      { path: "/pages/home-section/add", title: "Add Offer Card Section", type: "link" },
      { path: "/pages/home-section/home-section-list", type: "link", title: "Offer Card Section List" },
    ],
  },
  {
    title: "Orders",
    icon: FiBriefcase,
    type: "sub",
    badgeType: "primary",
    active: false,
    children: [
      { path: "/pages/orders", title: "All Orders", type: "link" },
    ],
  },
  {
    title: "Purchase",
    icon: FiTag,
    type: "sub",
    badgeType: "primary",
    active: false,
    children: [
      { path: "/pages/purchase-add", title: "Add Purchase", type: "link" },
      { path: "/pages/purchase-list", title: "Purchase List", type: "link" },
    ],
  },

  {
    title: "Products",
    icon: FiBox,
    type: "sub",
    badgeType: "primary",
    active: false,
    children: [
      { path: "/pages/products/add", title: "Add New", type: "link" },
      { path: "/pages/product-list", title: "All Products", type: "link" },
    ],
  },
  {
    title: "Users ",
    icon: TbUsers,
    type: "sub",
    active: false,
    children: [
      { path: "/pages/user/users-list", type: "link", title: "Users List " },
    ],
  },

  {
    title: "Notification",
    icon: FaRegBell,
    type: "sub",
    active: false,
    children: [
      { path: "/pages/notification/create", title: "Create Notification", type: "link" },
      { path: "/pages/notification/notification-list", type: "link", title: "Notification List" },
    ],
  },
  {
    title: "Home Sections",
    icon: LuSettings2,
    type: "sub",
    active: false,
    children: [
      { path: "/pages/feature-type/add", title: "Add New", type: "link" },
      { path: "/pages/feature-type/feature-type-list", type: "link", title: "All Home Sections" },
    ],
  },
  {
    title: "Reports",
    icon: FiFileText,
    type: "sub",
    active: false,
    children: [
      { path: "/pages/sales-report", title: "Sales Report", type: "link" },
      { path: "/pages/sales-count-report", title: "Sales Count Report", type: "link" },
      { path: "/pages/stock-report", title: "Stock Report", type: "link" },
    ],
  },
  {
    title: "Setting",
    icon: FiSettings,
    type: "sub",
    active: false,
    children: [
      { path: "/pages/manage-home-section", title: "Manage Home Sections", type: "link" },
      { path: "/pages/manage-currency", title: "Manage Currency", type: "link" },
    ],
  },


];
